import '../../App.css'


export default function HardwareSimulators() {
    return (
      <h2>hardware-simulators</h2>
    
    );
  }